import { useEffect } from "react";
import { create } from "zustand";

export type SmartNavigationState = {
  /** Whether smart navigation is active, including the phone overview default */
  isSmartNavigationEnabled: boolean;

  /** Change whether smart navigation is enabled */
  setIsSmartNavigationEnabled(isSmartNavigationEnabled: boolean): void;

  /** True while the smart navigation circle should be rendered over the 3D view */
  shouldShowSmartNavigationCircle: boolean;

  /** Change whether to show the smart navigation circle*/
  setShouldShowSmartNavigationCircle(show: boolean): void;
};

/** Store to share the smart navigation state between the 3D scene and the html overlay */
export const useSmartNavigationStore = create<SmartNavigationState>()(
  (set) => ({
    isSmartNavigationEnabled: false,
    setIsSmartNavigationEnabled(isSmartNavigationEnabled: boolean) {
      set({ isSmartNavigationEnabled });
    },
    shouldShowSmartNavigationCircle: false,
    setShouldShowSmartNavigationCircle(show: boolean) {
      set({ shouldShowSmartNavigationCircle: show });
    },
  }),
);

/**
 * Applies the phone overview default while preserving the setting outside that layout.
 *
 * @param isPhone Whether the overview is using the phone layout.
 */
export function usePhoneOverviewSmartNavigationDefault(isPhone: boolean): void {
  useEffect(() => {
    if (!isPhone) return;
    const { isSmartNavigationEnabled, setIsSmartNavigationEnabled } =
      useSmartNavigationStore.getState();
    setIsSmartNavigationEnabled(true);
    return () => setIsSmartNavigationEnabled(isSmartNavigationEnabled);
  }, [isPhone]);
}
